import Badge from '@repo/ui/badge'
import { useFormContext } from 'react-hook-form'

import { AssignJourneyToCenterInput } from '../../../../lib/types/models/center/center-input'
import { CenterProperties } from '../../../../lib/types/models/center/properties.center'

const TotalNumberOfStaffs = () => {
  const form = useFormContext<AssignJourneyToCenterInput>()
  const staffRequests = form.watch('staffRequests')
  return (
    <Badge
      text={`Nombre total d'encadrants : ${CenterProperties.getTotalNumberOfStaffs(staffRequests)}`}
      variant="warning"
    />
  )
}

export default TotalNumberOfStaffs
